import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'

interface SelectedChainStore {
  selectedChain: string
  setSelectedChain: (chain: string) => void
}

export const createSelectedChainStore = (storage: StateStorage) =>
  createStore<SelectedChainStore>(
    storage,
    (set) => ({
      selectedChain: 'all',
      setSelectedChain(selectedChain) {
        set({ selectedChain })
      },
    }),
    {
      persist: {
        name: 'selectedChain',
      },
    }
  )
